import { call, put, takeEvery, fork } from "redux-saga/effects";
import Swal from "sweetalert2";
import * as types from "./radActionType";
import * as actions from "./radActions";
import * as services from "./radServices";
import { downloadBase64File } from "../../../utils/fileDownloads";
import customViewSaga from "../customView/services/customViewSaga";
import watchRADListSaga from "../radList/services/RADListSaga";
import watchCapacityInputSaga from "../capacityInput/services/CapacityInputSaga";
import watchCapacityInputNewSaga from "../capacityInputNew/services/ProviderCapacityInputSaga";
import watchLeadershipBulkUpdateSaga from "../leadershipBulkUpdate/services/leadershipBulkUpdateSaga";
import watchAuditlogsSaga from "../auditLogs/AuditlogsServices/AuditlogsSaga";
import watcheditradprofileSaga from "../editRadProfileDuplicate/EditRadProfileServices/EditRadProfileSaga";
import watchRadHourlyVolumeShareSaga from "../hourlyVolumeShare/services/hourlyVolumeShareSaga";
import watchAnnualHourTrackerSaga from "../annualHourTracker/services/annualHourTrackerSaga";
import radProfileSaga from "../radProfile/services/radSaga";
import watchStateLicenseSaga from "../stateLicense/services/stateLicenseSaga";
import watchUnassignedProviderListSaga from "../unassignedProviderList/services/unassignedProviderListSaga";

// Custom Views - start
function* getAllCustomViewsSaga(action) {
  try {
    const response = yield call(services.getAllCustomViews, action.payload);
    if (response?.success) {
      yield put(actions.getAllCustomViewsSuccess(response.values));
    } else {
      yield put(actions.getAllCustomViewsFailure());
    }
  } catch (error) {
    console.error("Get All Custom Views Fetch Error:", error);
    yield put(actions.getAllCustomViewsFailure());
  }
}

function* getCustomViewFieldsSaga(action) {
  try {
    const response = yield call(services.getCustomViewFields, action.payload);
    if (response?.success) {
      yield put(actions.getCustomViewFieldsSuccess(response.values));
    } else {
      yield put(actions.getCustomViewFieldsFailure());
    }
  } catch (error) {
    console.error("Get Custom View Fields Fetch Error:", error);
    yield put(actions.getCustomViewFieldsFailure());
  }
}

function* saveCustomViewSaga(action) {
  try {
    const response = yield call(services.saveCustomView, action.payload);
    if (response?.success) {
      yield put(actions.saveCustomViewFieldsSuccess(response.values || {}));
      Swal.fire({
        icon: "success",
        title: "Success",
        text: response?.resultMessage || "Custom view saved successfully!",
        timer: 2000,
        showConfirmButton: false,
      });
      yield put(actions.getAllCustomViewsRequest());
      // navigate
    } else {
      yield put(actions.saveCustomViewFieldsFailure("Save failed"));
      Swal.fire("Error", response?.errorMessage || "Save failed", "error");
    }
  } catch (error) {
    console.error("Save Custom View Error:", error);
    yield put(
      actions.saveCustomViewFieldsFailure("Failed to save custom view"),
    );
    Swal.fire("Error", "Failed to save Custom View", "error");
  }
}

export default function* radSaga() {
  //Rad List
  // yield takeEvery(types.FETCH_RADLIST_REQUEST, fetchRadListSaga);

  // //Rad Capacity
  // yield takeEvery(types.FETCH_RADPROFILE_GETRADIOLOGIST_TASKBYID_REQUEST, fetchRadiologistTaskByIdSaga);
  // // yield takeEvery(types.DROPDOWN_FILTER_REQUEST, dropdownFilterSaga);
  // yield takeEvery(types.FETCH_CAPACITY_INPUT_REQUEST, fetchCapacityInputSaga);
  // yield takeEvery(types.FETCH_DEFAULT_RAD_CAPACITY_REQUEST, fetchDefaultRadCapacitySaga);
  // yield takeEvery(types.UPDATE_RAD_CAPACITY_INPUT_REQUEST, updateRadCapacityInputSaga);
  // yield takeEvery(types.BULK_UPDATE_RAD_CAPACITY_INPUT_REQUEST, bulkUpdateRadCapacityInputSaga);

  // yield takeEvery(types.RAD_CAPACITY_IP_UPLOAD_REQUEST, radCapacityIpUploadSaga);

  //Rad Profile
  // yield takeEvery(types.FETCH_RADPROFILE_REQUEST, fetchRadProfileSaga);
  // yield takeEvery(types.ADD_RAD_SCHEDULE_REQUEST, addRadScheduleSaga);
  // yield takeEvery(types.SAVE_RAD_SCHEDULE_REQUEST, saveRadScheduleSaga);
  // yield takeEvery(types.FETCH_RADPROFILE_GETRADIOLOGIST_TASKSBYDATE_REQUEST, fetchRadiologistTasksByDateSaga);
  // yield takeEvery(types.FETCH_RADPROFILE_ASSOCIATED_SITEMATRICS_REQUEST, fetchRadProfileAssociatedSiteMatricsSaga);
  // yield takeEvery(types.FETCH_RAD_SITE_MATRIX_DROPDOWN_REQUEST, fetchRadSiteMatrixDropdownSaga);
  // yield takeEvery(types.FETCH_RADPROFILE_GETSITEMETRICSCHILDTABLE_REQUEST, fetchSiteMetricsChildTableSaga);
  // yield takeEvery(types.FETCH_RADPROFILE_GETRADIOLOGIST_YTDBYID_REQUEST, fetchRadiologistYTDByIDSaga);
  // yield takeEvery(types.FETCH_RAD_DROPDOWN_TASKS_REQUEST, fetchRadDropdownTasksSaga);
  // yield takeEvery(types.DELETE_SHIFT_INPUT_DETAILS_REQUEST, deleteShiftInputDetailsSaga);
  // yield takeEvery(types.FETCH_SCHEDULES_BY_DATE_RANGE_REQUEST, fetchSchedulesByDateRangeSaga);
  // yield takeEvery(types.SAVE_RAD_REQUEST, saveRadSaga);

  // //Rad Leadership Bulk Upload - start
  // yield takeEvery(types.FETCH_RAD_LEADERSHIP_REQUEST, fetchRadLeadershipSaga);
  // yield takeEvery(types.RAD_LEADERSHIP_BULK_UPDATE_REQUEST, saveRadLeadershipBulkUpdateSaga);
  // yield takeEvery(types.CHECK_RAD_LEADERSHIP_EDIT_ACCESS_REQUEST, checkRadLeadershipEditAccessSaga);
  // yield takeEvery(types.DELETE_RAD_LEADERSHIP_BULK_UPDATE_USER_REQUEST, deleteRadLeadershipBulkUpdateUserSaga);
  // //Rad Leadership Bulk Upload - end

  // // Rad Hourly Volume Share - start
  // yield takeEvery(types.FETCH_RAD_HOURLY_VOLUME_SHARE_UN_READ_DETAILS_REQUEST, fetchRadHourlyVolumeShareUnReadDetailsSaga);
  // yield takeEvery(types.FETCH_RAD_HOURLY_VOLUME_SHARE_READ_DETAILS_REQUEST, fetchRadHourlyVolumeShareReadDetailsSaga);
  // yield takeEvery(types.EXPORT_RAD_HOURLY_VOLUME_SHARE_REQUEST, exportRadHourlyVolumeShareSaga);
  // yield takeEvery(types.GET_DORPDOWN_RAD_SITES_REQUEST, getDropdownRadSitesSaga);
  // yield takeEvery(types.GET_WORKLIST_BY_RPCE_ID_REQUEST, getWorklistRpceIDSaga);
  // yield takeEvery(types.GET_PRATICES_BY_WORKLIST_ID_REQUEST, getPracticeByWorklistIDSaga);
  // yield takeEvery(types.GET_SUB_PRATICES_BY_PRATICE_ID_REQUEST, getSubPracticeByPracticeIDSaga);
  // yield takeEvery(types.GET_SITE_BY_SUB_PRATICE_ID_REQUEST, getSiteBySubPraticeIDSaga);
  // // Rad Hourly Volume Share - end

  // //Annual Hour Tracker - start
  // yield takeEvery(types.FETCH_ANNUAL_HOUR_TRACKER_REQUEST, fetchAnnualHourTrackerSaga);
  // yield takeEvery(types.FETCH_ANNUAL_HOUR_TRACKER_DROPDOWN_REQUEST, fetchAnnualHourTrackerDropdownSaga);
  // yield takeEvery(types.FETCH_WORKLIST_BY_RPCE_REQUEST, fetchWorklistByRPCESaga);
  // yield takeEvery(types.FETCH_TASK_BY_WORKLIST_REQUEST, fetchTaskByWorklistSaga);
  // yield takeEvery(types.EXPORT_TO_CSV_REQUEST_ANNUAL_HOUR_TRACKER, exportCSVSagaAnnualHourTracker);
  // yield takeEvery(types.REFRESH_ANNUAL_HOUR_TRACKER_REQUEST, refreshAnnualHourTrackerSaga);
  // //Annual Hour Tracker - end

  // Custom Views - start
  yield takeEvery(types.GET_ALL_CUSTOM_VIEWS_REQUEST, getAllCustomViewsSaga);
  yield takeEvery(
    types.GET_CUSTOM_VIEW_FIELDS_REQUEST,
    getCustomViewFieldsSaga,
  );
  yield takeEvery(types.SAVE_CUSTOM_VIEW_FIELDS_REQUEST, saveCustomViewSaga);

  // New Custom View List - start
  yield fork(customViewSaga);
  // New Custom View List - end
  // Custom Views - end
  yield fork(watchRadHourlyVolumeShareSaga);
  yield fork(watchAnnualHourTrackerSaga);
  yield fork(radProfileSaga);
  yield fork(watchRADListSaga);
  yield fork(watchCapacityInputSaga);
  yield fork(watchCapacityInputNewSaga);
  yield fork(watchLeadershipBulkUpdateSaga);
  yield fork(watchAuditlogsSaga);
    yield fork(watcheditradprofileSaga);
    yield fork(watchStateLicenseSaga);
    yield fork(watchUnassignedProviderListSaga);
}
